import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IExtensionInfo } from '../../models';
import { SLICE_NAMES } from '../constants';

const initialState: IExtensionInfo = {
  extensionVersion: '',
  isInstalled: null,
  installedTime: 0,
};

const extensionInfoSlice = createSlice({
  name: SLICE_NAMES.EXTENSION_INFO,
  initialState,
  reducers: {
    setExtensionInfo: (state, action: PayloadAction<IExtensionInfo>) => {
      return { ...state, ...action.payload };
    },
    clearExtensionInfo: () => {
      return { ...initialState };
    },
  },
});

export const { setExtensionInfo, clearExtensionInfo } =
  extensionInfoSlice.actions;

export const extensionInfoReducer = extensionInfoSlice.reducer;
